// Lead Score Distribution Chart Component
// Pie chart showing breakdown by grade (A-F)

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PieChart as PieChartIcon } from 'lucide-react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { COLORS } from './analyticsConstants';

const LeadScoreChart = ({ leadScores }) => {
  if (!leadScores) return null;

  return (
    <Card className="border-slate-200" data-testid="lead-scores-chart">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <PieChartIcon className="w-5 h-5 text-teal-500" />
          Lead Score Distribution
        </CardTitle>
        <CardDescription>Breakdown by grade (A-F)</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <PieChart>
              <Pie
                data={leadScores.distribution}
                dataKey="count"
                nameKey="grade"
                cx="50%"
                cy="50%"
                outerRadius={80}
                label={({ grade, percentage }) => `${grade}: ${percentage}%`}
              >
                {leadScores.distribution.map((entry) => (
                  <Cell key={entry.grade} fill={COLORS.grades[entry.grade]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default LeadScoreChart;
